<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<fuse-loading-bar></fuse-loading-bar>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
